import $ from 'jquery';

// On récupère tous les tr
let table = $('table tr');

// On loop sur chaques tr en y ajoutant la classe active
table.each(function(index) {
    // On ajoute la classe 'active' aux 4 premiers tr
    if(index < 4) {
        $(this).addClass('active')
    } else {
    // On arrête l'ajout de classe à partir de 4 tr
        return false;
    }
});

// Evenement au click pour afficher plus d'éléments
$('a.load_more').on('click', function(e) {
    e.preventDefault(); 
    // Target éléments n'ayant pas la classe active
    let hiddenCell = table.not(".active");

    // Toggle la classe show-more pour afficher seulement ceux n'ayant pas la classe active
    hiddenCell.toggleClass("show-more");
    
    var text = $(this).text();
    $(this).text(
        text == "Voir plus" ? "Voir moins" : "Voir plus");
    $(this).toggleClass('load_less');

    $(this).parent().toggleClass('no-background');

    return false;
});